module.exports = __webpack_public_path__ + "img/the-teeth-monsters-bg.ded9079d.jpg";